import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./login.css";
import { loginUser } from './api'; 

const Login = () => {
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateEmailOrPhone = (value) => {
    if (!value.trim()) return "Email or phone is required";
    const isEmail = /\S+@\S+\.\S+/.test(value);
    const isPhone = /^\d{10}$/.test(value);
    if (!isEmail && !isPhone) return "Invalid email/phone address";
    return "";
  };

  const validatePassword = (value) => {
    if (!value.trim()) return "Password is required";
    if (value.length < 6) return "Password must be at least 6 characters";
    if (!/[A-Z]/.test(value)) return "Password must contain at least one uppercase letter";
    if (!/[!@#$%^&*(),.?\":{}|<>]/.test(value))
      return "Password must contain at least one special character";
    return "";
  };

  const handleBlur = (field, value) => {
    let newErrors = { ...errors };
    if (field === "emailOrPhone") newErrors.emailOrPhone = validateEmailOrPhone(value);
    if (field === "password") newErrors.password = validatePassword(value);
    setErrors(newErrors);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const emailError = validateEmailOrPhone(emailOrPhone);
    const passwordError = validatePassword(password);

    if (emailError || passwordError) {
      setErrors({ emailOrPhone: emailError, password: passwordError });
      return;
    }

    try {
      const response = await loginUser(emailOrPhone, password);

      if (response.status === 200 && response.data.auth) {
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("isLoggedIn", "true");

        // ✅ Save user with email for role checks
        localStorage.setItem("user", JSON.stringify({ email: emailOrPhone }));

        navigate("/HomePage");
      } else {
        alert("Invalid credentials");
      }
    } catch (error) {
      alert("Login failed. Please try again.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src="/favicon.ico" alt="Logo" className="logo-icon" />
        <h2 className="login-header">EnergyAtlas - EMS</h2>
        <form onSubmit={handleLogin}>
          <div className="input-container">
            <input
              type="text"
              className={`input-box ${errors.emailOrPhone ? "error" : ""}`}
              value={emailOrPhone}
              onChange={(e) => setEmailOrPhone(e.target.value)}
              onBlur={(e) => handleBlur("emailOrPhone", e.target.value)}
              placeholder=" "
            />
            <label className={errors.emailOrPhone ? "error-label" : ""}>Email / Phone *</label>
            {errors.emailOrPhone && <div className="error-message">{errors.emailOrPhone}</div>}
          </div>

          <div className="input-container">
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                className={`input-box ${errors.password ? "error" : ""}`}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={(e) => handleBlur("password", e.target.value)}
                placeholder=" "
              />
              <label className={errors.password ? "error-label" : ""}>Password *</label>
              <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
            {errors.password && <div className="error-message">{errors.password}</div>}
          </div>

          <button type="submit" className="login-buttons">LOGIN</button>
        </form>

        <div className="links">
          <a onClick={() => navigate("/signUp")}>Signup</a>
        </div>
        <div className="links">
          <a onClick={() => navigate("/ResetPassword")}>Reset Password</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
